export default {
  name: 'errorPage',
  created () {

  },
  data: function () {
    return {

    }
  },
  methods: {

  },
}
